'use client';

import { BundledExternalStyle } from '@dealerportal/ui-components/BundledExternalStyle';
import { useEffect } from 'react';
import { useShopifyScript } from './useShopifyScript';

interface ShopifyScriptConfig {
  scriptUrl?: string;
  cssUrl?: string;
  buttonSelector?: string;
  autoLoad?: boolean;
  onScriptLoad?: () => void;
  onScriptError?: (error: Error) => void;
}

interface ShopifyScriptProps {
  config?: ShopifyScriptConfig;
}

export const ShopifyScript = ({ config = {} }: ShopifyScriptProps) => {
  const {
    autoLoad = true,
    cssUrl = 'https://adhawk-marketplace-assets.s3-us-west-1.amazonaws.com/index.css',
    ...hookConfig
  } = config;

  const { isLoaded, loadScript, reregisterButtons } =
    useShopifyScript(hookConfig);

  // Auto-load script if configured to do so
  useEffect(() => {
    if (autoLoad && !isLoaded) {
      loadScript();
    }
  }, [autoLoad, isLoaded, loadScript]);

  // Expose global API for backward compatibility
  useEffect(() => {
    (window as any)['ShopifyScriptLoader'] = {
      loadScript,
      reregisterButtons,
      isLoaded,
    };

    return () => {
      delete (window as any)['ShopifyScriptLoader'];
    };
  }, [loadScript, reregisterButtons, isLoaded]);

  return (
    <BundledExternalStyle
      id="adhawk-shopify-camilyo-marketplace-link"
      href={cssUrl}
      layer="mosaic-bundler"
      cysOrigin="ShopifyScript"
    />
  );
};
